import logo from "../assets/csc-logo.png";

import { useState } from "react";

import {
  Link,
  useLocation,
  useNavigate
} from "react-router-dom";

import { useAuth }
  from "../context/AuthContext";

import { useCart }
  from "../context/CartContext";

import {
  LayoutDashboard,
  Calendar,
  ShoppingCart,
  LogOut,
  User,
  History
} from "lucide-react";

function Navbar() {

  const location = useLocation();

  const navigate = useNavigate();

  const {
    userProfile,
    isAuthenticated,
    logout
  } = useAuth();

  const {
    items
  } = useCart();

  const [hovered, setHovered] =
    useState(null);

  const NAV_ITEMS = [
    { label: "HOME", path: "/" },
    { label: "ABOUT", path: "/about" },
    { label: "COACHES", path: "/coaches" },
    { label: "CONTACT", path: "/contact" },
  ];

  const handleLogout = async () => {

    await logout();

    navigate("/");
  };

  return (

    <div style={styles.wrapper}>

      <div style={styles.navInner}>

        <Link
          to="/"
          style={styles.logoWrap}
        >
          <img
            src={logo}
            alt="logo"
            style={styles.logo}
          />
        </Link>

        <div style={styles.navbar}>

          {/* LEFT MENU */}

          <div style={styles.menu}>

            {NAV_ITEMS.map((item) => {

              const isActive =
                location.pathname === item.path;

              return (

                <Link
                  key={item.label}
                  to={item.path}
                  style={{
                    ...styles.link,
                    ...(hovered === item.label
                      ? styles.linkHover
                      : {}),
                    ...(isActive
                      ? styles.active
                      : {}),
                  }}
                  onMouseEnter={() =>
                    setHovered(item.label)
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  {item.label}
                </Link>
              );
            })}

          </div>

          {/* RIGHT SIDE */}

          <div style={styles.right}>

            {/* BOOK */}

            <button
              style={{
                ...styles.ctaButton,
                ...(hovered === "book"
                  ? styles.ctaButtonHover
                  : {}),
              }}
              onMouseEnter={() =>
                setHovered("book")
              }
              onMouseLeave={() =>
                setHovered(null)
              }
              onClick={() =>
                navigate("/search")
              }
            >
              BOOK
            </button>

            <div style={styles.divider}></div>

            {isAuthenticated ? (

              <div style={styles.iconGroup}>

                {/* DASHBOARD */}

                <Link
                  to="/dashboard"
                  style={{
                    ...styles.icon,
                    ...(hovered === "dashboard"
                      ? styles.iconHover
                      : {})
                  }}
                  onMouseEnter={() =>
                    setHovered("dashboard")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  <LayoutDashboard size={18} />
                </Link>

                {/* CALENDAR */}

                <Link
                  to="/bookings"
                  style={{
                    ...styles.icon,
                    ...(hovered === "calendar"
                      ? styles.iconHover
                      : {})
                  }}
                  onMouseEnter={() =>
                    setHovered("calendar")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  <Calendar size={18} />
                </Link>

                {/* HISTORY */}

                <Link
                  to="/history"
                  style={{
                    ...styles.icon,
                    ...(hovered === "history"
                      ? styles.iconHover
                      : {})
                  }}
                  onMouseEnter={() =>
                    setHovered("history")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  <History size={18} />
                </Link>

                {/* CART */}

                <div style={styles.iconWrapper}>

                  <Link
                    to="/cart"
                    style={{
                      ...styles.icon,
                      ...(hovered === "cart"
                        ? styles.iconHover
                        : {})
                    }}
                    onMouseEnter={() =>
                      setHovered("cart")
                    }
                    onMouseLeave={() =>
                      setHovered(null)
                    }
                  >
                    <ShoppingCart size={18} />
                  </Link>

                  {items.length > 0 && (

                    <span style={styles.badge}>
                      {items.length}
                    </span>

                  )}

                </div>

                {/* USER */}

                <div style={styles.userBox}>

                  <div style={styles.avatar}>
                    <User size={14} />
                  </div>

                  <span style={styles.username}>
                    {userProfile?.name || "User"}
                  </span>

                </div>

                {/* LOGOUT */}

                <button
                  onClick={handleLogout}
                  style={{
                    ...styles.iconBtn,
                    ...(hovered === "logout"
                      ? styles.iconHover
                      : {})
                  }}
                  onMouseEnter={() =>
                    setHovered("logout")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  <LogOut size={18} />
                </button>

              </div>

            ) : (

              <>
                <Link
                  to="/signin"
                  style={{
                    ...styles.signIn,
                    ...(hovered === "signin"
                      ? styles.signInHover
                      : {}),
                  }}
                  onMouseEnter={() =>
                    setHovered("signin")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  Sign In
                </Link>

                <Link
                  to="/signup"
                  style={{
                    ...styles.ctaButton,
                    ...(hovered === "signup"
                      ? styles.ctaButtonHover
                      : {}),
                  }}
                  onMouseEnter={() =>
                    setHovered("signup")
                  }
                  onMouseLeave={() =>
                    setHovered(null)
                  }
                >
                  Sign Up
                </Link>
              </>
            )}

          </div>

        </div>

      </div>

    </div>
  );
}

/* STYLES */

const styles = {

  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",

    position: "sticky",
    top: 0,
    zIndex: 1000,

    padding: "12px 0",

    /* transparent */
    background: "transparent",

    /* keeps blur glass effect */
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",

    /* IMPORTANT */
    overflow: "hidden",
    isolation: "isolate",

    /* invisible layer that blocks text bleed */
    boxShadow:
      "0 0 0 1000px rgba(5,15,30,0.01)",

    borderBottom:
      "1px solid rgba(255,255,255,0.06)",
  },

  navInner: {
    width: "100%",
    maxWidth: "1300px",
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "0 20px",
  },

  logoWrap: {
    display: "flex",
    textDecoration: "none"
  },

  logo: {
    height: "75px",
    cursor: "pointer"
  },

  navbar: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "rgba(0, 40, 70, 0.95)",
    padding: "18px 30px",
    borderRadius: "50px",
  },

  menu: {
    display: "flex",
    gap: "28px"
  },

  link: {
    color: "#d1d5db",
    padding: "10px 16px",
    borderRadius: "20px",
    textDecoration: "none",
    transition: "all 0.25s ease",
  },

  linkHover: {
    background: "rgba(255,255,255,0.1)",
    color: "#fff",
  },

  active: {
    background:
      "linear-gradient(90deg, #00f5a0, #00d9f5)",
    color: "#000",
    borderRadius: "20px",
    fontWeight: "bold",
  },

  right: {
    display: "flex",
    alignItems: "center",
    gap: "18px"
  },

  divider: {
    width: "1px",
    height: "28px",
    background: "rgba(255,255,255,0.2)",
  },

  ctaButton: {
    padding: "12px 26px",
    borderRadius: "999px",
    border: "none",
    fontWeight: "bold",
    background:
      "linear-gradient(90deg, #00ff88, #00d4ff)",
    color: "#0a1a0a",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all 0.3s ease",
    boxShadow:
      "0 6px 18px rgba(0,255,136,0.25)",
  },

  ctaButtonHover: {
    transform: "translateY(-2px) scale(1.03)",
    boxShadow:
      "0 12px 30px rgba(0,255,136,0.4)",
  },

  signIn: {
    color: "#d1d5db",
    textDecoration: "none",
  },

  signInHover: {
    color: "#00f5a0",
  },

  iconGroup: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  icon: {
    color: "#ccc",
    padding: "6px",
    textDecoration: "none",
    transition: "all 0.25s ease",
  },

  iconBtn: {
    background: "transparent",
    border: "none",
    color: "#ccc",
    padding: "6px",
    cursor: "pointer",
    transition: "all 0.25s ease",
  },

  iconWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },

  iconHover: {
    color: "#00ff88",
    filter:
      "drop-shadow(0 0 6px rgba(0,255,136,0.7))",
  },

  badge: {
    position: "absolute",
    top: "-4px",
    right: "-6px",
    background: "#00ff88",
    color: "#0a1a0a",
    fontSize: "10px",
    fontWeight: "bold",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  userBox: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  avatar: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background:
      "linear-gradient(90deg, #00ff88, #00d4ff)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
  },

  username: {
    fontSize: "13px",
    color: "#fff",
  },
};

export default Navbar;